<template>
<!--Support-->
  <pulse-loader color="#000000" size="10px"></pulse-loader>
<!--  {{id}}-->
<!--  {{device}}-->
<!--  {{source}}-->
<!--  {{paymentid}}-->
</template>

<script>

import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "MobSupport",
  components: {
    PulseLoader
  },
  data(){
    return{
      id: this.$route.query.encrid,
      device:this.$route.query.device,
      source:this.$route.query.source,
      paymentid:this.$route.query.paymentid,
    }
  },
  mounted() {

    let encrid = this.$route.query.encrid
      function initFreshChat() {
        // console.log("DataID"+this.$route.query.encrid)
  window.fcWidget.init({
    config: {
      cssNames: {
        expanded: "custom_fc_expanded",
        widget: "custom_fc_frame",

      },
    },
    open: "true",
    token: "ad940638-0ac0-4e1e-bce2-dbcfe565ebf5",
    host: "https://wchat.eu.freshchat.com",
    externalId: encrid
  });
}
function initialize(i, t) {
  var e;
  i.getElementById(t)
    ? initFreshChat()
    : (((e = i.createElement("script")).id = t),
      (e.async = !0),
      (e.src = "https://wchat.eu.freshchat.com/js/widget.js"),
      (e.onload = initFreshChat),
      i.head.appendChild(e));
}
function initiateCall() {
  initialize(document, "Freshchat-js-sdk");
}
window.addEventListener
  ? window.addEventListener("load", initiateCall, !1)
  : window.attachEvent("load", initiateCall, !1);

  },
};
</script>

<style scoped>
.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}
</style>